import formatMoney from './formatMoney';
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param   {Boolean} round - if true, will round to nearest Dollar
 * @param   {Boolean} ceil - if true, will round Upwards to nearest Dollar
 * @param  {String} format - shop money_format setting
 * @param {Boolean} removeHTML - If True will strip out \u003c\/span\u003e and \u003cspan class=money\u003e
 * @return {String} value - formatted value
 */
export default function formatMoneyCurrencyConversion(
  cents,
  round = false,
  ceil = false,
  // eslint-disable-next-line
    format = '${{amount}}',
  removeHTML = true
) {
  let priceInCents = cents;

  /**
   * Uncomment the following block to support Shopify multi-currency
   * and convert prices from store currency to the currency selected by
   * the user (aka "presentment" currency).
   * Please note that this relies on the `Shopify.currency` object exposed
   * by Shopify, which is an undocumented feature and can change at any time.
   */
  if (
    typeof window.Shopify !== 'undefined' &&
    typeof window.Shopify.currency !== 'undefined' &&
    typeof window.Shopify.currency.rate !== 'undefined' &&
    typeof window.Shopify.currency.active !== 'undefined'
  ) {
    // Convert to "presentment" currency using the rate provided by Shopify
    priceInCents *= parseFloat(window.Shopify.currency.rate);

    /**
     * Shopify uses different rounding strategies for different currencies.
     * The logic below might need to be customised based on the active currencies.
     * Note: Please only include currencies other than your store currency.
     */

    // if (window.Shopify.currency.active === 'EUR') {
    //   priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95;
    // } else if (
    //     window.Shopify.currency.active === 'GBP' ||
    //     window.Shopify.currency.active === 'USD' ||
    //     window.Shopify.currency.active === 'DKK'
    // ) {
    //   priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100;
    // }
  }

  if (round && priceInCents !== cents) {
    priceInCents = Math.round(priceInCents / 100) * 100;
  }

  if (ceil && priceInCents !== cents) {
    priceInCents = Math.ceil(priceInCents / 100) * 100;
  }
  return formatMoney(priceInCents, format, removeHTML);
}
